module.exports = __webpack_public_path__ + "img/css_sprites-left.1de4286.png";